import CourseDetail from '../feature/Courses/CourseDetail'

const CourseDetailPage = () => {
  
  return  <CourseDetail/>
 
}

export default CourseDetailPage